import VanForComponents from './index.vue';

export {
  VanForComponents,
};

export default VanForComponents;
